var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("h1", { staticStyle: { "text-align": "center" } }, [
        _c("strong", [_vm._v("隐私政策")])
      ]),
      _vm._v(" "),
      _c("p", { staticStyle: { "text-align": "right" } }, [
        _c("strong", [_c("strong", [_vm._v("编号：【】")])])
      ]),
      _vm._v(" "),
      _c("p", [_c("strong", [_c("strong", [_vm._v(" ")])])]),
      _vm._v(" "),
      _c("p", { staticStyle: { "text-align": "right" } }, [
        _vm._v("更新日期：    年  月  日")
      ]),
      _vm._v(" "),
      _c("p", { staticStyle: { "text-align": "right" } }, [
        _vm._v("生效日期：    年  月  日")
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("         "), _c("strong", [_vm._v("1.前言")])]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "         1.1.本隐私政策适用于南阳商祺数贸科技有限公司（以下或称“我们”）通过其运营的祺信平台（网址：pay.37cpep.com，以下简称“平台”）为您提供的服务。"
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("         "),
        _c("strong", [
          _vm._v(
            "1.2.平台主要面向企业提供服务，平台的用户不包括自然人，因此，我们收集的信息主要为企业的信息，其中涉及的个人信息的仅包括企业用户的操作员（包括用户直接授权的管理员、管理员指定的经办员和复核员）的个人信息，本隐私政策主要针对企业用户操作员的个人信息保护规则进行说明。"
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "         1.3当您通过我们的平台、以及我们的线下经营场所等渠道使用我们的服务、参加相关活动或与我们进行联系或其他互动时，我们可能会收集并使用您的个人信息。本隐私政策包含我们会收集您的哪些个人信息，以及如何收集、存储、使用、传输、提供和删除（以下或统称“处理”）这些个人信息。因此，完整地阅读本隐私政策可以帮助您了解自己在使用我们服务时，我们如何处理您的个人信息以及您可以如何管理您的个人信息。"
        ),
        _c("strong", [
          _vm._v(
            "如您不同意本隐私政策的任何内容，请您立即停止使用我们提供的服务。当您使用我们提供的服务时，即表示您已同意我们按照本隐私政策来合法处理您的个人信息。请仔细阅读此隐私政策，如有任何问题，您可通过本隐私政策第"
          )
        ]),
        _c("strong", [_vm._v("1")]),
        _c("strong", [_vm._v("1条所述的联系方式联系我们。")])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "         1.4我们的平台可能会包含其他第三方的网站/商品/服务的链接，这些第三方链接独立于我们，我们无权控制或管理该等第三方的网站/商品/服务，我们对该等第三方的网站/商品/服务不作任何保证。此外，我们的平台或线下经营场所等渠道上可能会包含第三方经营的商品/服务。如果您向此类第三方提供任何信息，对于您的个人信息的处理适用该等第三方自有的隐私政策。本隐私政策不适用于该等任何第三方向您提供的网站/商品/服务。"
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("         "),
        _c("strong", [_vm._v("2.")]),
        _c("strong", [_vm._v("我们如何收集和使用您的信息")])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("         "),
        _c("strong", [
          _vm._v(
            "2.1根据相关法律法规及国家标准，我们可能在下列情形下依法处理您的个人信息："
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("         2.1.1取得您的同意；")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "         2.1.2为订立、履行您作为一方当事人的合同所必需，或者按照依法制定的劳动规章制度和依法签订的集体合同实施人力资源管理所必需；"
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "         2.1.3为履行法定职责或者法定义务所必需，如反洗钱、反恐怖融资、反电信网络诈骗、实名管理等相关法律法规要求的必要信息；"
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "         2.1.4为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；"
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "         2.1.5为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；"
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "         2.1.6依照《中华人民共和国个人信息保护法》规定在合理的范围内处理个人自行公开或者其他已经合法公开的个人信息；"
        )
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("         2.1.7法律法规规定的其他情形。")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("         "),
        _c("strong", [
          _vm._v(
            "需要注意的是，当您的个人信息处理属于前述第2.1.2至第2.1.7项情形时，我们可能会依据所适用法律法规的要求而无需再征得您的同意。"
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("         "),
        _c("strong", [
          _vm._v(
            "2.2在您使用平台的各项业务功能（以下简称“服务”）的过程中，我们需要在以下情形收集您的一些信息，用以向您所在的企业提供服务以及符合国家法律法规规定："
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("         2.2.1用户注册与管理")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "         为了使您所在的企业进行平台用户注册和用户管理，企业需要授权具体人员作为其使用平台的操作员，代表企业进行意思表示。为此，我们将收集您作为平台用户操作员的个人信息，包括登录名、姓名、"
        ),
        _c("strong", [_c("strong", [_vm._v("身份证号")])]),
        _vm._v("、部门、手机号、电子邮箱、用户角色、启用状态、"),
        _c("strong", [_c("strong", [_vm._v("手持身份证照片")])]),
        _vm._v("。"),
        _c("strong", [_vm._v("前述加粗信息属于您的敏感个人信息")]),
        _vm._v("，"),
        _c("strong", [
          _c("strong", [
            _vm._v(
              "如您不同意提供前述信息，您将无法代表所在的企业进行用户注册与管理。"
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("         2.2.2用户行为")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "         当您在平台使用我们的服务时，系统会收集您互动时所涉及的IP地址、浏览器的类型、"
        ),
        _c("strong", [
          _c("strong", [_vm._v("访问日期和时间、软硬件特征信息及网页记录信息")])
        ]),
        _vm._v("。")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "         此外，我们使用cookies储存用户访问平台的相关数据，在您访问或再次访问平台时，我们能识别用户身份，并通过分析数据为您提供更好更多的服务。您有权选择接受或拒绝接受cookies。您可以通过修改浏览器的设置以拒绝接受cookies，但是我们需要提醒您，如您拒绝接受cookies，您可能无法使用依赖于cookies的我们网站的部分功能。"
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("         "),
        _c("strong", [_vm._v("3.")]),
        _c("strong", [
          _vm._v("我们如何共享、转让、公开披露、委托处理您的个人信息")
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("         "),
        _c("strong", [
          _vm._v(
            "3.1共享：一般情况下，我们不会与我们以外的任何机构或个人共享您的个人信息，但您理解并同意以下情况例外："
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("         3.1.1事先获得您明确的同意或授权。")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "         3.1.2根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况下进行提供。"
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("         "),
        _c("strong", [
          _vm._v(
            "3.2转让：我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外："
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("         "),
        _c("strong", [
          _vm._v(
            "3.2.1在获取明确同意的情况下转让：事先获得您明确的同意或授权；"
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "         3.2.2根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进行转让；"
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "         3.2.3在涉及合并、分立、解散、被宣告破产等情形时，如涉及个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本隐私政策的约束，否则，我们将要求该公司、组织重新向您征求授权同意。"
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("         "),
        _c("strong", [
          _vm._v(
            "3.3公开披露：我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才会公开披露您的个人信息："
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "         3.3.1获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息；"
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("         "),
        _c("strong", [
          _vm._v("3.3.2根据法律、法规的要求、强制性的行政执法或司法要求；")
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("         "),
        _c("strong", [
          _vm._v("3.3.3"),
          _c("strong", [
            _vm._v(
              "为保护我们员工、其他客户或其他公众的权利、财产或个人安全所必需。"
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("         "),
        _c("strong", [
          _vm._v(
            "3.4委托处理：我们可能委托专业技术服务机构或人员为我们提供系统开发、运维服务等方面的支持，其中可能涉及个人信息的处理。对我们委托处理个人信息的主体，我们会与其约定委托处理的目的、期限、处理方式、个人信息的种类、保护措施以及双方的权利和义务等，并对受托人的个人信息处理活动进行监督。"
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("         "),
        _c("strong", [_vm._v("4.")]),
        _c("strong", [_vm._v("我们如何进行存储和保护您的个人信息")])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("         "),
        _c("strong", [
          _vm._v(
            "4.1我们会按照法律法规规定，将在中华人民共和国境内收集的个人信息储存于中国境内。"
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("         "),
        _c("strong", [
          _vm._v(
            "4.2我们在为您提供满足服务目的所必需且最短的期间内保存您的个人信息，除非需要延长保存期限或受到法律的允许。在超出存储期限后，我们会对您的个人信息进行删除或匿名化处理，但法律法规或监管部门另有规定的除外。如您不再作为所在企业的授权操作员，收到相关变更材料后，我们将停止使用您的个人信息。"
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("         "), _c("strong", [_vm._v("4.3保护措施")])]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "         4.3.1为保障您的个人信息安全，我们将努力采取各种合理的物理、电子和管理方面的安全措施来保护您的个人信息，使其免受泄露、毁损或者丢失的风险。"
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "         4.3.2互联网环境并非百分之百安全，我们将尽力确保您发送给我们的任何信息的安全性。"
        ),
        _c("strong", [
          _c("strong", [
            _vm._v(
              "您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的不可抗力因素而出现问题。因此，我们强烈建议您采取积极措施保护个人信息的安全，包括但不限于使用复杂密码，定期修改密码，不将账号密码和相关个人信息提供给他人等。"
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "         4.3.3在发生或者可能发生您的信息泄露、毁损、丢失等安全事件时，我们会立即采取相应的补救措施，按照法律法规的规定和监管部门的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。"
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("         "),
        _c("strong", [_vm._v("5.")]),
        _c("strong", [_vm._v("未成年人保护")])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("         "),
        _c("strong", [
          _c("strong", [
            _vm._v(
              "5.1我们的服务仅面向成人，不面向18周岁以下的未成年人。未成年人不应成为企业用户授权的操作员。"
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("         "),
        _c("strong", [_vm._v("6.")]),
        _c("strong", [_vm._v("您的个人信息如何管理")])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("         "),
        _c("strong", [_vm._v("6.1查阅、复制、更正、补充您的个人信息")])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "         您对您的个人信息享有知情权、决定权。除法律法规规定外，您有权随时通过第11条中的联系方式对您的个人信息进行查阅、复制、更正、补充。"
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("         "),
        _c("strong", [_vm._v("6.2删除您的个人信息")])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("         在以下情形中，您可以向我们提出删除个人信息的请求：")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "         （1）如果我们的处理目的已实现、无法实现或者为实现处理目的不再必要；"
        )
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("         （2）如果我们终止服务及运营；")]),
      _vm._v(" "),
      _c("p", [_vm._v("         （3）如果您撤回同意，或者您注销了用户账号；")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "         （4）如果我们处理个人信息的行为违反法律、行政法规或者与您的约定；"
        )
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("         （5）法律、行政法规规定的其他情形。")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "         如果您需要删除您在使用我们服务过程中的个人信息，您可以通过第11条中的联系方式联系我们，在您提出合理要求并经我们验证核实您的身份后，我们会回复您的删除请求。"
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "         若我们决定响应您的删除请求，我们还将同时尽可能通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体已获得您的独立授权。"
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "         当您或我们协助您删除相关信息后，因为适用的法律和安全技术限制，我们可能无法立即从系统中删除相应的信息，我们将安全地存储您的个人信息并限制对其的任何进一步的处理，直到可以删除或实现匿名化。"
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("         "),
        _c("strong", [_vm._v("6.3改变您授权同意的范围或撤回您的授权")])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "         您可以通过不再作为所在企业的授权操作员的方式，撤回我们继续收集您个人信息的全部授权。"
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("         "),
        _c("strong", [
          _c("strong", [
            _vm._v(
              "请您理解，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。"
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("         "),
        _c("strong", [_vm._v("6.4个人信息的转移")])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "         您有权请求将您的个人信息转移至您指定的个人信息处理者。如您需要转移您的个人信息，您可以通过第11条中的联系方式联系我们。在符合国家网信部门规定条件且技术可行的前提下，我们将根据您的要求将您的个人信息转移至您指定的个人信息处理者。"
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("         "),
        _c("strong", [_vm._v("6.5对个人信息处理规则的解释说明")])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "         您可以通过第11条中的联系方式联系我们对个人信息处理情况进行解释说明。"
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("         "),
        _c("strong", [_vm._v("6.6响应您的上述请求")])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "         为保障安全，我们可能会先要求您验证自己的身份，然后再处理您的请求。您可能需要提供书面请求，或以其他方式证明您的身份。对于您的请求，我们原则上将于15日内做出答复。"
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "         对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝，但会向您说明理由。"
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("         您理解，在以下情形中，我们将无法响应您的请求：")
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("         （1）与国家安全、国防安全直接相关的；")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("         （2）与公共安全、公共卫生、重大公共利益直接相关的；")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("         （3）与犯罪侦查、起诉、审判和判决执行等直接相关的；")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("         （4）有充分证据表明您存在主观恶意或滥用权利的；")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "         （5）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；"
        )
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("         （6）涉及商业秘密的。")]),
      _vm._v(" "),
      _c("p", [_vm._v("         "), _c("strong", [_vm._v("7.账户注销")])]),
      _vm._v(" "),
      _c("p", [
        _vm._v("         "),
        _c("strong", [
          _vm._v(
            "7.1您知晓，您作为所在企业在平台开设用户的操作员，未经您企业的审核授权，你无权注销平台用户。如您所在的企业需要注销账户的，具体要求详见《用户服务协议》。"
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("         "), _c("strong", [_vm._v("8.责任限制")])]),
      _vm._v(" "),
      _c("p", [
        _vm._v("         "),
        _c("strong", [
          _c("strong", [
            _vm._v(
              "8.1如您将密码告知他人或与他人共享平台账户，由此导致的任何个人资料泄露或权益丧失，我们无需为此承担责任。"
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("         "),
        _c("strong", [
          _c("strong", [
            _vm._v(
              "8.2我们十分重视您账户和隐私信息的安全，并将竭尽全力保护您的隐私。但我们无法保证不会出现任何由于黑客攻击、计算机病毒侵入或发作、因政府管制而造成的暂时性关闭等影响网络正常经营的不可抗力事件而造成的个人资料泄露、丢失、被盗用或被篡改等。一旦您发现账户出现异常，请及时与我们联系。"
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("         "), _c("strong", [_vm._v("9.举报")])]),
      _vm._v(" "),
      _c("p", [
        _vm._v("         "),
        _c("strong", [
          _c("strong", [
            _vm._v(
              "您在我们平台上不得发布法律、法规所禁止发布或者传输的信息、不得有泄露他人身份、散布他人隐私等侵害他人合法权益的行为。如我们发现您有上述行为，我们有权立即停止传输该信息并采取消除等处置措施，保存有关记录，并向有关主管部门报告。"
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "         如您发现他人存在上述行为或在我们平台上发现任何网络安全隐患且有合理理由相信个人信息已经或将要受到侵犯，您可通过我们公布的联系方式向我们进行信息安全投诉、举报，我们将会在第一时间受理并处理。"
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("         "),
        _c("strong", [_vm._v("10.政策的通知和修订")])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "         根据我们的业务和法律规定的变化，本隐私政策也将随之进行修订。如相关更新造成您在本隐私政策下权利的实质减少或重大变更，我们将在更新政策生效前通过在显著位置予以提示、向您发送推送消息、在您登录时弹窗通知、或以其他方式通知您，"
        ),
        _c("strong", [
          _c("strong", [
            _vm._v(
              "若您在本隐私政策更新后继续使用我们的服务，即表示您充分阅读、理解并同意更新后的隐私政策。若您不同意更新后的隐私政策，您有权并应立即停止使用我们的服务。"
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("         "), _c("strong", [_vm._v("11.如何联系我们")])]),
      _vm._v(" "),
      _c("p", [
        _vm._v("         "),
        _c("strong", [
          _vm._v(
            "11.1如果您对本隐私政策有任何疑问、意见或建议，您可以通过以下方式与我们联系："
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("         电话：4000377900")]),
      _vm._v(" "),
      _c("p", [_vm._v("         电子邮箱：sqsm@37cpep.com")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "         地址：河南省南阳市卧龙区七里园乡美盛白河湾商业楼44号楼106号"
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("         "),
        _c("strong", [
          _vm._v(
            "11.2请您理解，在您联系我们时，我们可能会要求您进行身份验证，以保障您的个人信息安全。若您拒绝提供相应证明材料，我们将无法响应您的请求。此外，由于技术所限、法律或监管要求，我们可能无法满足您的所有要求，一般情况下，我们会在15日内答复您的请求。"
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("         "),
        _c("strong", [
          _vm._v(
            "11.3因本隐私政策以及我们处理您个人信息事宜引起的任何争议，您可随时联系我们并要求进行回复，"
          ),
          _c("strong", [
            _vm._v(
              "如果您对我们的回复不满意的，认为我们的个人信息处理行为严重损害了您的合法权益的，您还可以通过向河南省南阳市卧龙区"
            )
          ]),
          _c("strong", [_vm._v("有管辖权的人民法院提起诉讼来寻求解决方案。")])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d3974bfc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3974bfc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/privacy.vue
// module id = KdDw
// module chunks = 1